/** Reorder elements in an array with a from and to index. This produces a new array and does not mutate the original. */
export function arrayMove<T>(arr: Array<T>, fromIndex: number, toIndex: number): Array<T> {
  const newArray = [...arr];
  const [movedElement] = newArray.splice(fromIndex, 1);
  newArray.splice(toIndex, 0, movedElement);
  return newArray;
}
